/**
 * Created by admin on 2018/5/22.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Checkbox, Icon, Input, Modal, Tooltip } from 'antd';
import { PATH_HOME, PATHS, ROLES_KEY } from '../../utils/constants';
import './RoleEditModal.less';
import IconTip from '../IconTip';
import { Btn, RequiredSign } from '../Widgets';

class RoleEditModal extends PureComponent {
  static defaultProps = {
    visible: false,
    allMenus: [],
    editRole: {}
  };

  constructor() {
    super();
    this.state = {
      roleId: '',
      roleKey: '',
      roleName: '',
      editMenus: [], //正在编辑的角色的菜单信息
      reportTerm: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.visible && nextProps.visible) {
      const { editRole } = nextProps;
      if (editRole && editRole.menus) {
        this.setState({
          roleId: editRole.id,
          roleKey: editRole.roleKey,
          roleName: editRole.name,
          editMenus: [].concat(editRole.menus)
        });
      } else {
        this.setState({
          roleId: '',
          roleKey: '',
          roleName: '',
          editMenus: [], //正在编辑的角色的菜单信息
          reportTerm: ''
        });
      }
    }
  }

  render() {
    const { visible, allMenus = [], intl } = this.props;
    const { roleId, roleKey, roleName, editMenus, reportTerm } = this.state;

    return (
      <Modal
        visible={visible}
        onCancel={this.close}
        title={
          roleId
            ? intl.formatMessage({ id: 'role_manage_edit_role' })
            : '新增角色'
        }
        wrapClassName="role-edit-wrapper modal-close-header"
        width={1024}
        footer={
          <div className="edit-footer">
            <Btn onClick={this.close}>
              {intl.formatMessage({ id: 'dialog_btn_cancel' })}
            </Btn>
            <Btn primary onClick={this.save}>
              {intl.formatMessage({ id: 'dialog_btn_ok' })}
            </Btn>
          </div>
        }
        closable
      >
        <div className="role-edit">
          <div className="role-name">
            <div className="prefix-title">
              <RequiredSign />
              <FormattedMessage id="role_manage_role_name" />
            </div>
            <Input
              value={roleName}
              onChange={e => this.setState({ roleName: e.target.value })}
              disabled={this.checkDefaultRole() && roleId} //默认角色不允许修改角色名
            />
          </div>
          <div className="role-menu">
            <div className="prefix-title">
              <FormattedMessage id="role_manage_permission" />
            </div>
            <div className="menu-tree">
              {allMenus.map((menu, i) => {
                const { children: childMenus = [] } = menu;
                const checkAll =
                  !!editMenus.find(em => em.id === menu.id) &&
                  childMenus.every(
                    childMenu => !!editMenus.find(em => em.id === childMenu.id)
                  );
                const indeterminate =
                  !checkAll && !!editMenus.find(em => em.id === menu.id);
                const disabled = roleKey === ROLES_KEY.admin && roleId;
                const isReportMenu = `${PATH_HOME}${menu.url}` === PATHS.report;
                return (
                  <div key={i} className="menu-tree-row">
                    <div className="menu-tree-parent">
                      <IconTip title={menu.menuDesc}>{menu.name}</IconTip>
                      <Checkbox
                        disabled={disabled}
                        indeterminate={indeterminate}
                        checked={checkAll}
                        onChange={this.onCheckAll.bind(this, menu)}
                      >
                        <FormattedMessage id="role_manage_all" />
                      </Checkbox>
                    </div>
                    <div
                      className={
                        isReportMenu ? 'menu-report-tree' : 'menu-tree-child'
                      }
                    >
                      {/*{*/}
                      {/*isReportMenu ? <Input*/}
                      {/*placeholder={intl.formatMessage({id:'report_custom_name_placeholder'})}*/}
                      {/*prefix={<Icon type="search"/>}*/}
                      {/*value={reportTerm}*/}
                      {/*onChange={e => this.setState({reportTerm: e.target.value})}*/}
                      {/*/> : null*/}
                      {/*}*/}
                      <div className="menu-wrapper">
                        {childMenus.map((childMenu, j) => {
                          if (
                            isReportMenu &&
                            childMenu.name.indexOf(reportTerm) === -1
                          ) {
                            return null;
                          }
                          return (
                            <div key={j}>
                              <Checkbox
                                disabled={this.checkMenuImmutable(childMenu)}
                                checked={
                                  !!editMenus.find(em => em.id === childMenu.id)
                                }
                                onChange={this.onCheck.bind(this, {
                                  menu,
                                  childMenu
                                })}
                              >
                                <IconTip title={childMenu.menuDesc}>
                                  {childMenu.name}
                                </IconTip>
                              </Checkbox>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  onCheckAll = (menu, e) => {
    let { editMenus = [] } = this.state;
    const { children: childMenus = [] } = menu;
    if (e.target.checked) {
      if (!editMenus.find(em => em.id === menu.id)) {
        editMenus.push(menu);
      }
      for (let childMenu of childMenus) {
        if (!editMenus.find(em => em.id === childMenu.id)) {
          editMenus.push(childMenu);
        }
      }
    } else {
      if (!this.checkMenuImmutable(menu)) {
        editMenus.splice(editMenus.findIndex(em => em.id === menu.id), 1);
      }
      for (let childMenu of childMenus) {
        if (!this.checkMenuImmutable(childMenu)) {
          editMenus.splice(
            editMenus.findIndex(em => em.id === childMenu.id),
            1
          );
        }
      }
    }
    this.setState({ editMenus: [].concat(editMenus) });
  };

  onCheck = ({ menu, childMenu }, e) => {
    let { editMenus = [] } = this.state;
    const { children: childMenus = [] } = menu;
    if (e.target.checked) {
      editMenus.push(childMenu);
      if (!editMenus.find(em => em.id === menu.id)) {
        editMenus.push(menu);
      }
    } else {
      editMenus.splice(editMenus.findIndex(em => em.id === childMenu.id), 1);
      if (childMenus.every(cm => !editMenus.find(em => em.id === cm.id))) {
        editMenus.splice(editMenus.findIndex(em => em.id === menu.id), 1);
      }
    }
    this.setState({ editMenus: [].concat(editMenus) });
  };

  /**
   * 特定角色的特定菜单是禁止修改的，这个方法会检查当前修改的角色是否能修改该菜单
   * 需注意的是，如果二级菜单是不可修改的，则它的父菜单也会判断成不可修改
   * */
  checkMenuImmutable = menu => {
    const { roleKey } = this.state;
    const url = `${PATH_HOME}${menu.url}`;
    if (roleKey) {
      switch (roleKey) {
        case ROLES_KEY.admin:
          return true;
        case ROLES_KEY.svc_admin: //服务管理员不允许修改服务管理权限
          return (
            url === PATHS.serviceManage ||
            url === PATHS.videoManage ||
            url === PATHS.account
          );
        case ROLES_KEY.room_admin: //会议室管理员不允许修改会议室管理权限
          return url === PATHS.roomManage || url === PATHS.account;
        case ROLES_KEY.device_admin: //设备管理员不允许修改设备管理权限
          return url === PATHS.deviceManage || url === PATHS.account;
        default:
          return false;
      }
    }
    return false;
  };

  /**
   * 检查当前角色是否为默认角色
   * */
  checkDefaultRole = () => {
    const { roleKey } = this.state;
    return !!roleKey;
  };

  save = () => {
    const { roleId, roleKey, roleName, editMenus } = this.state;
    const { dispatch, loading } = this.props;
    if (loading) return; //避免某个傻逼连续点击导致弹窗关了又开
    if (!roleName) {
      Modal.error({ content: '角色名称不能为空！' });
    } else {
      const promise = new Promise((resolve, reject) => {
        dispatch({
          type: 'role/save',
          roleId,
          roleKey,
          roleName,
          menus: editMenus,
          resolve,
          reject
        });
      });
      promise.then(
        () => {
          this.close();
        },
        msg => {
          Modal.error({ content: msg });
        }
      );
    }
  };

  close = () => {
    const { onCancel } = this.props;
    this.setState({
      roleId: '',
      roleName: '',
      editMenus: [],
      reportTerm: ''
    });
    onCancel && onCancel();
  };
}

const mapStateToProps = state => {
  return {
    allMenus: state.role.allMenus,
    loading: state.loading.models.role
  };
};

export default connect(mapStateToProps)(injectIntl(RoleEditModal));



// WEBPACK FOOTER //
// ./src/components/account/RoleEditModal.js